const config = {
    api: {
        //baseUrl: 'http://localhost:3000',
        baseUrl: 'https://proserdcespb.ru:3066',
        //baseUrl: 'https://seemeworking.com:3066',
    },
};

export default config;
